import type { UnsubscribeRequest } from "@/modules/events/types/eventDetailsApi"
import type { UseMutationResult } from "@tanstack/react-query"

import { useMutation } from "@tanstack/react-query"

import { getUnsubscribe } from "@/modules/events/api/getUnsubscribe"

export const useUnsubscribe = (): UseMutationResult<void, Error, UnsubscribeRequest> =>
  useMutation<void, Error, UnsubscribeRequest>({ mutationFn: getUnsubscribe })
